import { render, staticRenderFns } from "./QuestionOpen.vue?vue&type=template&id=325befb0&scoped=true"
import script from "./QuestionOpen.vue?vue&type=script&lang=js"
export * from "./QuestionOpen.vue?vue&type=script&lang=js"
import style0 from "./QuestionOpen.vue?vue&type=style&index=0&id=325befb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325befb0",
  null
  
)

export default component.exports